/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectRoleDTO } from './ProjectRoleDTO';
import {
    ProjectRoleDTOFromJSON,
    ProjectRoleDTOFromJSONTyped,
    ProjectRoleDTOToJSON,
} from './ProjectRoleDTO';

/**
 * 
 * @export
 * @interface NewProjectMemberDTO
 */
export interface NewProjectMemberDTO {
    /**
     * 
     * @type {string}
     * @memberof NewProjectMemberDTO
     */
    userId: string;
    /**
     * 
     * @type {ProjectRoleDTO}
     * @memberof NewProjectMemberDTO
     */
    role: ProjectRoleDTO;
}



/**
 * Check if a given object implements the NewProjectMemberDTO interface.
 */
export function instanceOfNewProjectMemberDTO(value: object): value is NewProjectMemberDTO {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function NewProjectMemberDTOFromJSON(json: any): NewProjectMemberDTO {
    return NewProjectMemberDTOFromJSONTyped(json, false);
}

export function NewProjectMemberDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewProjectMemberDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'role': ProjectRoleDTOFromJSON(json['role']),
    };
}

export function NewProjectMemberDTOToJSON(value?: NewProjectMemberDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'role': ProjectRoleDTOToJSON(value['role']),
    };
}

